export const getVariationOptionValue = (option) =>
  String(option?._id ?? option?.label ?? "");

export const findVariationOption = (options, selectedValue) =>
  (options || []).find(
    (option) => getVariationOptionValue(option) === String(selectedValue)
  );

export const getSelectedVariationValue = (productVariations, variationName) => {
  const selected = productVariations?.find((item) => item.name === variationName);
  if (!selected) return null;

  const value = selected._id ?? selected.label;
  return value == null || value === "" ? null : String(value);
};

export const getVisibleVariationOptions = (options) =>
  (options || []).filter((option) => option.visible !== false);

export const updateProductVariations = (current, variation, selectedOption) => {
  const storedId = selectedOption._id ?? selectedOption.label;
  const entry = {
    name: variation.name,
    _id: storedId,
    label: selectedOption.label,
  };

  const list = [...(current || [])];
  const index = list.findIndex((item) => item.name === variation.name);

  if (index >= 0) {
    list[index] = entry;
  } else {
    list.push(entry);
  }

  return list;
};
